import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

interface HowItWorksStep {
    label: string;
    detail: string;
}

@Component({
    selector: 'app-penny-how-it-works-dialog',
    templateUrl: './penny-how-it-works-dialog.component.html',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PennyHowItWorksDialogComponent {
    @Input() open = false;
    @Output() closed = new EventEmitter<void>();

    readonly steps: HowItWorksStep[] = [
        {
            label: 'Homeowner asks a question',
            detail: 'A homeowner types a question in natural language about payments, community rules, pool hours, or anything else. No special format required.',
        },
        {
            label: 'AI chatbot searches knowledge',
            detail: 'AI chatbot instantly searches through PayHOA Help Articles (always available) and any community documents you\'ve uploaded. AI finds the most relevant information.',
        },
        {
            label: 'Instant, sourced answer',
            detail: 'AI chatbot provides a clear, helpful answer with a source citation so homeowners know exactly where the information comes from. Responses take just 1-2 seconds.',
        },
        {
            label: 'Human handoff if needed',
            detail: 'If AI chatbot can\'t answer a question, it offers to connect the homeowner with a board member or manager. You stay in control.',
        },
    ];
}
